import {
    GET_TARIFF_HEADS,
    GET_TARIFF_HEADS_WITH_DETAILS,
    GET_TARIFF_HEAD_DETAILS,
    CREATE_TARIFF_HEAD,
    UPDATE_TARIFF_HEAD,
    UPDATE_TARIFF_HEAD_STATUS,
    DELETE_TARIFF_HEAD
} from '../../index.types';

// Get All Tariff Heads
export const getTariffHeads = (data) => ({
    type: GET_TARIFF_HEADS,
    data
});

// Get Tariff Heads With Details (rates, meterSlabs, taxRule)
export const getTariffHeadsWithDetails = (data) => ({
    type: GET_TARIFF_HEADS_WITH_DETAILS,
    data
});

// Get Tariff Head Details
export const getTariffHeadDetails = (data) => ({
    type: GET_TARIFF_HEAD_DETAILS,
    data
});

// Create Tariff Head
export const createTariffHead = (data) => ({
    type: CREATE_TARIFF_HEAD,
    data
});

// Update Tariff Head
export const updateTariffHead = (data) => ({
    type: UPDATE_TARIFF_HEAD,
    data
});

// Update Tariff Head Status (Activate/Deactivate)
export const updateTariffHeadStatus = (data) => ({
    type: UPDATE_TARIFF_HEAD_STATUS,
    data
});

// Delete Tariff Head
export const deleteTariffHead = (data) => ({
    type: DELETE_TARIFF_HEAD,
    data
});
